import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'splitLines' })
export class SplitLinesPipe implements PipeTransform {

  transform(value: string, size: number = 75): string[] {
    if (!value) return null;

    const regex: RegExp = new RegExp('.{1,' + size + '}', 'g');

    return value.match(regex) || [];
  }

}
